<template>
  <div>
    <v-card class="mx-auto mt-4" max-width="95%" elevation="2">
      <v-toolbar color="#37474F" dark>
        <v-toolbar-title>공지 이력</v-toolbar-title>
        <v-spacer/>
        <v-btn color="lime" small fab @click="OnClick_CreateItem">
          <v-icon color="blue-grey darken-3">mdi-plus</v-icon>
        </v-btn>
      </v-toolbar>
      <v-list>
        <div style="overflow-x: auto;">
          <v-data-table
            :footer-props="{'items-per-page-options': [20, 50, -1]}"
            :headers="headers"
            :items="notice_list"
            :loading="loadingData"
          >
            <template v-slot:item="row">
              <tr>
                <td>{{ row.item.id }}</td>
                <td>{{ row.item.title }}</td>
                <td>{{ summarize(row.item.message) }}</td>
                <td>
                  <v-chip x-small :color="row.item.notice_type === 'hidden' ? 'grey' : 'blue lighten-4'">
                    {{ row.item.notice_type === 'hidden' ? '숨김' : '일반' }}
                  </v-chip>
                </td>
                <td>{{ row.item.created_by }}</td>
                <td>{{ formatDate(row.item.created_at) }}</td>
                <td>
                  <v-switch v-model="row.item.is_enabled" inset @change="Save_Change_ActiveState(row.item)"></v-switch>
                </td>
                <td>
                  <v-btn class="mx-1" fab dark x-small color="blue darken-1" @click="OnClickEdit_Item(row.item)">
                    <v-icon dark small>mdi-pencil-outline</v-icon>
                  </v-btn>
                  <v-btn class="mx-1" fab dark x-small color="red darken-1" @click="OnClickDelete_Item(row.item)">
                    <v-icon dark small>mdi-delete-outline</v-icon>
                  </v-btn>
                </td>
              </tr>
            </template>
          </v-data-table>
        </div>
      </v-list>
    </v-card>
  </div>
</template>

<script>
import { mandoora_notice } from '../../api/mandoora';

export default {
  name: 'MandooraGameNotice',
  data: () => ({
    loadingData: false,
    notice_list: [],
    headers: [
      { text: '고유번호', value: 'id' },
      { text: '타이틀', value: 'title' },
      { text: '내용 요약', value: 'message' },
      { text: '타입', value: 'notice_type' },
      { text: '작성자', value: 'created_by' },
      { text: '작성일', value: 'created_at' },
      { text: '활성상태', value: 'is_enabled' },
      { text: '관리', value: 'actions', sortable: false },
    ],
  }),
  created() {
    this.LoadNoticeList();
  },
  methods: {
    formatDate(v) {
      if (!v) return '';
      return String(v).replace('T', ' ').slice(0, 16);
    },
    summarize(html) {
      if (!html) return '';
      const text = String(html).replace(/<[^>]*>/g, '').replace(/&nbsp;/g, ' ').trim();
      return text.length > 40 ? text.substring(0, 40) + '...' : text;
    },
    async LoadNoticeList() {
      this.loadingData = true;
      try {
        const body = await mandoora_notice.get_notice_list();
        this.notice_list = (body && body.notice_list) ? body.notice_list : [];
      } catch (e) {
        console.error('[Mandoora Notice] get_notice_list', e);
      } finally {
        this.loadingData = false;
      }
    },
    async Save_Change_ActiveState(item) {
      try {
        await mandoora_notice.set_notice({
          id: item.id,
          notice_title: item.title,
          notice_message: item.message,
          is_enabled: item.is_enabled,
          notice_type: item.notice_type,
        });
        alert(item.is_enabled ? '공지가 활성화 되었습니다.' : '공지가 비활성화 되었습니다.');
        await this.LoadNoticeList();
      } catch (e) {
        console.error('[Mandoora Notice] set_notice', e);
        alert('상태 변경 실패');
        await this.LoadNoticeList();
      }
    },
    OnClick_CreateItem() {
      this.$router.push('/mandoora/notice_write');
    },
    OnClickEdit_Item(item) {
      this.$router.push(`/mandoora/notice_write?id=${item.id}`);
    },
    async OnClickDelete_Item(item) {
      if (!confirm(`공지 [${item.title}] 을(를) 삭제하시겠습니까?`)) return;
      try {
        await mandoora_notice.delete_notice({ id: item.id });
        alert('삭제되었습니다.');
        await this.LoadNoticeList();
      } catch (e) {
        console.error('[Mandoora Notice] delete_notice', e);
        alert('삭제 실패');
      }
    },
  },
};
</script>
